<template>
<div class="tracking-tighter text-xxs sidebar flex-none max-h-screen overflow-hidden overflow-y-scroll inline-block border-r border-gray-100">
  <div class="p-6 w-300" v-if="selectedNode">
    <EditGeneral :selectedNode="selectedNode" :mainSelectedNode="selectedNode" @modelUpdate="modelUpdate"/>
    <!-- <CodeDisplay :value="selectedNode" class="pt-4"/> -->
  </div>
</div>

</template>
<script>

import EditGeneral from './EditGeneral'
import { Pixel } from '../../core/src/lib'
import CodeDisplay from '../../core/src/components/CodeDisplay'

export default {
  components: {
    EditGeneral,
    CodeDisplay
  },

  data() {
    return {
      selectedNode: null
    }
  },
  mounted() {
    this.selectedNode = Pixel.getSelectedNode()
    Pixel.on('selectedNodeChanged', (node) => {
      this.selectedNode = node
      
    })
  },
  methods: {
    modelUpdate(object) {
      this.$emit('modelUpdate', object)
    }
  },
}
</script>
<style scoped lang="scss">
  .w-300{
    width: 300px;
  }

  .sidebar {
    width: 300px;
    transition: width 0.1s ease-in-out;
  }
  .sidebar.hide {
    width: 0px;
    border: none;
  }
  .sidebar.hide .sidebar__footer, .sidebar.hide .nav-item .nav-item__text {
    display: none;
  }
 
</style>
